module.exports = __webpack_public_path__ + "img/img_crm_memo.09c3520a.svg";